import {
  Button,
  Card,
  Col,
  Input,
  Pagination,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Modal,
  message,
  App,
} from "antd";
import { Option } from "antd/es/mentions";
import { ArrowDownOutlined, ArrowUpOutlined, LeftOutlined, LoadingOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { LIST_COURSE_LEANERS, LEANERS_COURSE_STATUS, BULD_ASSIGN_PACKAGE_COURSE_TEMPLATE } from "../../../apis/apis";
import debounce from "lodash.debounce";
import CulsightPageLoader from "../../../components/CulsightPageLoader";
import AssignLeaners from "./AssignLeaners";
import BulkEnrollLearners from "./BulkEnrollLearners";

function CourseLearners() {
  const { notification } = App.useApp();
  const Navigate = useNavigate();
  const location = useLocation();
  const course_title =
    location.state?.title || localStorage.getItem("course_title") || "Course";

  const { course_id } = useParams();
  const [loader, setLoader] = useState(true);
  const [pagination_loader, set_pagination_loader] = useState(false);
  const [table_data, set_table_data] = useState([]);
  const [current_page, set_current_page] = useState(1);
  const [total_pages, set_total_pages] = useState(0);
  const [total_learners, set_total_learners] = useState(0);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [search_paceholder, set_search_paceholder] = useState("Search by name");
  const [search_query_name, set_search_query_name] = useState("");
  const [search_query_email, set_search_query_email] = useState("");
  const [search_query_select, set_search_query_select] = useState("Name");
  const [assignKey, setAssignKey] = useState(0);
  const [statusModalVisible, setStatusModalVisible] = useState(false);
  const [selectedLearner, setSelectedLearner] = useState(null);


  const handleBack = () => {
    if (location.state?.from) {
      Navigate(location.state.from);
    } else {
      Navigate(-1);
    }
  };


  const showModal = () => {
    setAssignKey((prev) => prev + 1);
    setIsModalVisible(true);
  };
  const showEnrollModal = () => setIsModalOpen(true);
  const CancelEnrollModal = () => setIsModalOpen(false);



  const handleDownloadTemplate = async () => {
    try {
      const response = await BULD_ASSIGN_PACKAGE_COURSE_TEMPLATE();

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = "bulk_add_course_learners_template.csv";
      document.body.appendChild(link);
      link.click();
      link.remove();

      notification.success({
        message: "Template Downloaded",
        description: "Excel template downloaded successfully",
      });
    } catch (error) {
      notification.error({
        message: "Download Failed",
        description: "Something went wrong",
      });
    }
  };



  const fetchLearners = async () => {
    setLoader(true);
    const FORM_DATA = new FormData();
    FORM_DATA.append("course_id", atob(course_id));
    const API_CALL = await LIST_COURSE_LEANERS(FORM_DATA);
    if (API_CALL?.data?.status) {
      set_table_data(API_CALL?.data?.data);
      set_current_page(API_CALL?.data?.current_page);
      set_total_pages(API_CALL?.data?.total_pages);
      set_total_learners(API_CALL?.data?.total_learners);
    }
    setLoader(false);
  };


  const handleModalCancel = async () => {
    setIsModalVisible(false);
    await fetchLearners();
  };


  const closeEnrollModal = async () => {
    setIsModalOpen(false);
    await fetchLearners();
  };

  useEffect(() => {
    fetchLearners();
  }, [course_id]);

  // Search dropdown
  const selectBefore = (
    <Select
      defaultValue="Name"
      onChange={(value) => {
        set_search_query_name("");
        set_search_query_email("");
        if (value === "Name") {
          set_search_paceholder("Search by name");
          set_search_query_select("Name");
        } else {
          set_search_paceholder("Search by email");
          set_search_query_select("Email");
        }
      }}
    >
      <Option value="Name">Name</Option>
      <Option value="Email">Email</Option>
    </Select>
  );

  // Table columns
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (text, record) => <span>{record.first_name} {record.last_name}</span>,
    },
    {
      title: "Email",
      dataIndex: "email",
      render: (text, record) => <span>{record.email}</span>,
    },
    {
      title: "Progress",
      key: "progress",
      render: (text, record) => <span>{record.progress}%</span>,
    },
    {
      title: "Course Status",
      key: "status",
      render: (text, record) => <span>{record.course_status}</span>,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            danger
            type="primary"
            size="small"
            onClick={() => {
              setSelectedLearner(record);
              setStatusModalVisible(true);
            }}
          >
            Unassign
          </Button>
        </Space>
      ),
    },
    {
      title: "Complete Report",
      dataIndex: "Report",
      key: "Report",
      render: (_, record) => (
        <Button type="link" onClick={() => Navigate(`/learner-report/${course_id}/${btoa(record.id)}`)}>
          View Report
        </Button>
      ),
    },
  ];

  const pagination_on_change = async (page) => {
    set_pagination_loader(true);
    const FORM_DATA = new FormData();
    FORM_DATA.append("page", page);
    FORM_DATA.append("token", localStorage.getItem("token"));
    FORM_DATA.append("name", search_query_name);
    FORM_DATA.append("email", search_query_email);
    FORM_DATA.append("course_id", atob(course_id));
    const API_CALL = await LIST_COURSE_LEANERS(FORM_DATA);
    if (API_CALL?.data?.status) {
      set_table_data(API_CALL?.data?.data);
      set_current_page(API_CALL?.data?.current_page);
      set_total_learners(API_CALL?.data?.total_learners);
    }
    set_pagination_loader(false);
  };


  const handleInput = debounce(async (e) => {
    const value = e.target.value;
    set_pagination_loader(true);
    const FORM_DATA = new FormData();
    FORM_DATA.append("course_id", atob(course_id));
    FORM_DATA.append("name", search_query_select === "Name" ? value : "");
    FORM_DATA.append("email", search_query_select === "Email" ? value : "");
    const API_CALL = await LIST_COURSE_LEANERS(FORM_DATA);
    if (API_CALL?.data?.status) {
      set_table_data(API_CALL?.data?.data);
      set_current_page(API_CALL?.data?.current_page);
      set_total_learners(API_CALL?.data?.total_learners);
    }
    set_pagination_loader(false);
  }, 500);

  return (
    <div className="lms-body">
      <Card className="card-bg">
        <Row>
          <Col span={12}>
            <h2>
              <span style={{ cursor: "pointer" }} onClick={handleBack}>
                <LeftOutlined />
              </span>{" "}
              {course_title} - Learners
            </h2>
          </Col>
        </Row>

        <Row gutter={[16, 16]} style={{ marginTop: 20 }}>
          <Col xs={24} sm={24} md={12} lg={12}>
            <Input
              addonBefore={selectBefore}
              placeholder={search_paceholder}
              onChange={handleInput}
              size="large"
            />
          </Col>

          <Col xs={24} sm={12} md={4} lg={4}>
            <Button
              variant="solid"
              color="green"
              size="large"
              style={{width:"100%"}}
              className="responsive-btn"
              onClick={handleDownloadTemplate}
            >
              Download Template
            </Button>
          </Col>
          {/* <Col xs={24} sm={12} md={4} lg={4}>
            <Button type="primary" size="large" icon={<ArrowDownOutlined />} style={{ width: "100%" }}>
              Complete Report
            </Button>
          </Col> */}

          <Col xs={24} sm={12} md={4} lg={4}>
            <Button
              type="primary"
              size="large"
              icon={<ArrowUpOutlined />}
              className="responsive-btn"
              onClick={showEnrollModal}
              style={{width:"100%"}}
            >
              Bulk Assign
            </Button>
          </Col>

          <Col xs={24} sm={12} md={4} lg={4}>
            <Button
              type="primary"
              size="large"
              className="responsive-btn"
              onClick={showModal}
              style={{width:"100%"}}
            >
              Assign Learners
            </Button>
          </Col>
        </Row>

        {loader ? (
          <CulsightPageLoader />
        ) : (
          <>
            {pagination_loader ? (
              <div style={{ textAlign: "center", padding: "60px" }}>
                <Spin indicator={<LoadingOutlined spin />} size="large" />
              </div>
            ) : (
              <Table
                rowKey={(record) => record.id}
                columns={columns}
                pagination={false}
                dataSource={table_data}
                style={{ marginTop: "15px" }}
              />
            )}

            {total_pages > 0 && (
              <div style={{ float: "right", marginTop: "20px" }}>
                <Pagination
                  onChange={pagination_on_change}
                  current={current_page}
                  total={total_learners}
                />
              </div>
            )}

            {total_pages === 0 && (
              <div style={{ textAlign: "center", color: "red" }}>
                <h2>No Learners Found</h2>
              </div>
            )}
          </>
        )}
      </Card>


      <Modal
        title="Assign Course to Learners"
        open={isModalVisible}
        onCancel={handleModalCancel}
        footer={null}
        width={800}
      >
        <AssignLeaners key={assignKey} onClose={handleModalCancel} course_id={course_id} />
      </Modal>


      <Modal
        title="Bulk Enroll Learners"
        open={isModalOpen}
        onCancel={CancelEnrollModal}
        footer={null}
        width={800}
      >
        <BulkEnrollLearners
          course_id={course_id}
          isModalOpen={isModalOpen}
          onSuccess={closeEnrollModal}
        />
      </Modal>


      <Modal
        title="Change Learner Status"
        open={statusModalVisible}
        onCancel={() => setStatusModalVisible(false)}
        footer={[
          <Button
            key="unassign"
            danger
            type="primary"
            onClick={async () => {
              const formData = new FormData();
              formData.append("course_id", atob(course_id));
              formData.append("learner_id", selectedLearner?.id);
              try {
                const res = await LEANERS_COURSE_STATUS(formData);
                if (res?.data?.status) {
                  notification.success({
                    message: "Successful",
                    description: res?.data?.message,
                  });
                  await fetchLearners();
                } else {
                  message.error("Unassign failed.");
                }
              } catch (err) {
                message.error("API error while unassigning.");
              }
              setStatusModalVisible(false);
            }}
          >
            Unassign
          </Button>,
          <Button key="cancel" onClick={() => setStatusModalVisible(false)}>Cancel</Button>,
        ]}
      >
        <p>
          Are you sure you want to unassign{" "}
          <strong>{selectedLearner?.first_name} {selectedLearner?.last_name}</strong> from this course?
        </p>
      </Modal>
    </div>
  );
}

export default CourseLearners;
